var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 61,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.115 5c-9.77 0-17.691 7.92-17.691 17.692 0 9.77 7.92 17.691 17.691 17.691 9.771 0 17.692-7.92 17.692-17.691C64.807 12.92 56.887 5 47.115 5ZM24.424 22.692C24.424 10.159 34.584 0 47.115 0c12.533 0 22.692 10.16 22.692 22.692a22.596 22.596 0 0 1-4.976 14.181l10.014 10.014a2.5 2.5 0 1 1-3.536 3.536L61.295 40.409a22.596 22.596 0 0 1-14.18 4.974c-12.532 0-22.691-10.159-22.691-22.691Zm24.67-10.614a2.5 2.5 0 0 0-5 0V24.19a2.5 2.5 0 1 0 5 0V12.078Zm.097 19.908a2.595 2.595 0 1 1-5.191 0 2.595 2.595 0 0 1 5.19 0ZM2.5 19.578a2.5 2.5 0 0 1 2.5 2.5v19.7l9.43-8.8a2.5 2.5 0 0 1 3.596.19l10.06 11.607 1.687-1.688 3.535 3.536-3.586 3.586a2.5 2.5 0 0 1-3.657-.13l-10.12-11.677L5 48.618v7.324h41.136a2.5 2.5 0 1 1 0 5H2.5a2.5 2.5 0 0 1-2.5-2.5V22.078a2.5 2.5 0 0 1 2.5-2.5Z",
    fill: "#bdbfa4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartNoData);
export default __webpack_public_path__ + "static/media/Chart-No-Data.7437e49448fbf346d27e213f6d3b8922.svg";
export { ForwardRef as ReactComponent };